<mat-toolbar class="row no-gutters">
  <div class="brand col d-flex">
    <img src="../../../favicon.ico" class="app-icon" />
    <span class="ml-auto" *ngIf="!menuCollapsed">AUJS</span>
  </div>
</mat-toolbar>
<acs-menu *ngIf="userLoggedIn; else emptyMenu" class="aujs-menu-directive flex-fill d-flex flex-column"></acs-menu>
<ng-template #emptyMenu>
  <div class="flex-fill d-flex flex-column"></div>
</ng-template>
<div class="row no-gutters">
  <button mat-button (click)="toggleMenuCollapse()" [ngStyle]="{'text-align': menuCollapsed ? 'center' : 'left'}" class="col ml-2">
    <fa-icon [icon]="collapsedStateIcon" class="fa fa-lg collapse-icon"></fa-icon>
    <span *ngIf="!menuCollapsed">{{'acs-menu.collapse.label' | translate}}</span>
  </button>
</div>

